/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:512fdb31-344d-4beb-a6dd-8f5ad3091eb5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Jcy1tYt0p",
    "aws_user_pools_web_client_id": "3m62suo1pe183guj8e8diae0kj",
    "oauth": {
        "domain": "us-east-1jcy1tyt0p.auth.us-east-1.amazoncognito.com"
    },
    "google_client_id": "750380676052-hsvck1q6b6mbd4tpk6ak7m6a5hr2i1ed.apps.googleusercontent.com",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
